import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { API_BASE_URL } from "../../config/api";

const MusicBanner = ({ user }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    if (user?.id) {
      fetch(`${API_BASE_URL}/check-subscription`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: user.id }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.isSubscribed) setIsSubscribed(true);
        })
        .catch(() => {});
    }
  }, [user?.id]);

  if (!isVisible || isSubscribed) return null;

  return (
    <div
      className="bg-forest-800 text-forest-100 py-3 px-4 relative"
      style={{ paddingTop: "max(12px, env(safe-area-inset-top, 12px))" }}
    >
      {/* Dismiss Button - centered vertically with content */}
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsVisible(false);
        }}
        onTouchEnd={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsVisible(false);
        }}
        className="absolute right-2 text-forest-300 hover:text-gold-300 active:text-gold-300 transition-colors z-10 dismiss-button p-2"
        style={{
          top: "50%",
          transform: "translateY(-50%)",
          minWidth: "44px",
          minHeight: "44px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        title="Dismiss banner"
      >
        <X className="w-5 h-5" />
      </button>

      {/* Banner Content */}
      <div className="max-w-6xl mx-auto pr-6">
        <div className="flex items-center justify-center gap-4 flex-wrap">
          {/* Left Social Links */}
          <div className="flex gap-3 order-1 desktop-social">
            <a
              href="https://open.spotify.com/artist/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-forest-200 hover:text-gold-300 transition-colors"
            >
              Spotify
            </a>

            <a
              href="https://youtube.com/@PRIMEAPE-music"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-forest-200 hover:text-gold-300 transition-colors"
            >
              YouTube
            </a>

            <a
              href="https://primeape.bandcamp.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-forest-200 hover:text-gold-300 transition-colors"
            >
              Bandcamp
            </a>
          </div>

          {/* Center - "Check out my music!" links to main site */}
          <div className="text-center order-2">
            <a
              href="https://primeape.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-forest-100 glow-text-subtle hover:text-gold-300 transition-colors"
            >
              Check out my music!
            </a>
          </div>

          {/* Right Social Links */}
          <div className="flex gap-3 order-3 desktop-social">
            <a
              href="https://tiktok.com/@primeape.music"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-forest-200 hover:text-gold-300 transition-colors"
            >
              TikTok
            </a>

            <a
              href="https://instagram.com/primeape.music"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-forest-200 hover:text-gold-300 transition-colors"
            >
              Instagram
            </a>

            <a
              href="https://music.apple.com/artist/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-forest-200 hover:text-gold-300 transition-colors"
            >
              Apple Music
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicBanner;
